<div class="container">
	<div class="text-center" style="color: white;">
		<i class="fa fa-cog fa fa-4x fa fa-spin fa-no-margin"></i>
		<h3>Logging out...</h3>
	</div>
</div>